import { Texture } from "@pixi/core";
import { Container } from "@pixi/display";
import { Sprite } from "@pixi/sprite";

export class DotsIndicator extends Container {
    private dots: Array<Sprite>;

    constructor(
        private readonly activedDotTexture: Texture,
        private readonly dotTexture: Texture,
        total: number
    ) {
        super();
        this.dots = new Array<Sprite>();
        this.createDots(total);
    }

    private createDots(total: number) {
        for (let i = 0; i < total; i++) {
            const dot = new Sprite(this.dotTexture);
            dot.x = (dot.width + 26) * i;
            this.addChild(dot);
            this.dots.push(dot);
        }
        this.update(0, 1);
    }

    public update(activeIndex: number, previousActiveIndex: number) {
        this.dots[previousActiveIndex].texture = this.dotTexture;
        this.dots[activeIndex].texture = this.activedDotTexture;
    }
}